import React from 'react';

import useDotLottie from '../../../commons/hooks/useDotLottie';
import CommonImages from '../../../commons/images';

function EcalLoading (props) {
  const {
    className,
    loop = true,
    autoplay = true,
  } = props;

  const { canvasRef } = useDotLottie({
    src: CommonImages.ECAL_LOADING_LOTTIE,
    loop,
    autoplay,
  });

  return (
    <canvas
      ref={canvasRef}
      width={260}
      height={100}
      className={className}
      style={{
        display: 'block',
        width: '260px',
        height: '100px',
        background: 'transparent',
        overflow: 'hidden',
      }}
    />
  );
}

export default EcalLoading;
